import {Pipe, PipeTransform} from '@angular/core';
import {RecipientStatus} from '../types/recipient';

@Pipe({
  name: 'recipientStatus',
  standalone: false,
})
export class RecipientStatusPipe implements PipeTransform {
  transform(value: string): string {
    switch (value) {
      case RecipientStatus.ACTIVE:
        return 'Active';
      case RecipientStatus.INACTIVE:
        return 'Inactive';
      case RecipientStatus.PENDING_COMPLIANCE:
        return 'Pending Compliance';
      case RecipientStatus.FAILED_COMPLIANCE:
        return 'Failed Compliance';
      default:
        return 'Unknown Status';
    }
  }
}
